import SEOArticleLayout from "@/components/feature/SEOArticleLayout";
import { comparisonOopbuy } from "@/mocks/articles";

export default function HipobuyVsOopbuy() {
  return (
    <SEOArticleLayout
      slug={comparisonOopbuy.slug}
      title={comparisonOopbuy.title}
      metaDescription={comparisonOopbuy.metaDescription}
      publishDate={comparisonOopbuy.publishDate}
      readTime={comparisonOopbuy.readTime}
      badge={comparisonOopbuy.badge}
      heroImage={comparisonOopbuy.heroImage}
      sections={comparisonOopbuy.sections}
      relatedArticles={[
        { label: "Complete Guide", to: "/hipobuy-spreadsheet-complete-guide" },
        { label: "vs Kakobuy", to: "/hipobuy-spreadsheet-vs-kakobuy" },
        { label: "vs CSSBuy", to: "/hipobuy-spreadsheet-vs-cssbuy" },
        { label: "vs Superbuy", to: "/hipobuy-spreadsheet-vs-superbuy" },
        { label: "Category Deep-Dive", to: "/hipobuy-spreadsheet-category-deep-dive" },
      ]}
    />
  );
}